import { render, staticRenderFns } from "./Asset-NewSite.vue?vue&type=template&id=6fbed78c&scoped=true&"
import script from "./Asset-NewSite.vue?vue&type=script&lang=ts&"
export * from "./Asset-NewSite.vue?vue&type=script&lang=ts&"
import style0 from "./Asset-NewSite.vue?vue&type=style&index=0&id=6fbed78c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbed78c",
  null
  
)

export default component.exports